import Phaser from "phaser";
import CardGameObject, { Card } from "./Card.js";

import { socket, socketConnected } from "../../../../utils/nakama";
import { matchIdGame, displayResurrectModal } from "../../Game.jsx";
import opCodes from "../../../../constants/opCodes.jsx";

export default class CardSlot extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, scale, card, cardIndex, rotation) { //card should be a card object.
        super(scene, x, y, 'all_images', 'empty_card_slot');
        //this.setTexture(emptyTexture);
        this.setRotation(rotation);
        this.setDepth(2);
        this.scale = scale;
        //this.emptyTexture = emptyTexture;        
        this.updateSlot(card, cardIndex);
        this.listenerLoaded = false;
    }

    resurrectSteal(resurrectIndex, cardIndex) { //resurrectIndex is the index of "steal" in playerPowerCardsPlayed
        if (this.resurrectStealCard) {
            this.resurrectStealCard.destroy();
        }

        this.resurrectStealCard = this.scene.add.card(this.scene.input.x + 170, this.scene.input.y + 184, new Card("steal", 1, null, false)).setDepth(998);
        this.resurrectStealOnMove = (pointer) => {
            this.resurrectStealCard.handleDrag(pointer.x + 170, pointer.y + 184); //offset card from pointer position
            this.scene.opponentBoard.setStealBorder(pointer.x, pointer.y);
        }
        this.scene.input.on("pointermove", this.resurrectStealOnMove);

        this.resurrectStealOnDown = async (pointer) => {
            this.scene.opponentBoard.setStealBorder(this.x, this.y); //remove steal border
            this.scene.input.off("pointermove", this.resurrectStealOnMove);
            this.scene.input.off("pointerdown", this.resurrectStealOnDown);

            let index = this.scene.opponentBoard.determineIndex(pointer.x, pointer.y);
            if (index !== -1 && socketConnected && matchIdGame !== "") { //card functionality
                const data = {
                    "name": "resurrect",
                    "option": {
                        resurrectIndex: resurrectIndex,
                        resurrectOption: index,
                    },
                    "cardIndex": cardIndex,
                }
                try {
                    console.log("Steal resurrect power card play requested on card index " + resurrectIndex);
                    await socket.sendMatchState(matchIdGame, opCodes.playerPlayPowerCard, JSON.stringify(data));
                } catch (err) {
                    console.log("Error resurrecting steal power card: ", err);
                }
            }

            this.resurrectStealCard.destroy();
            this.resurrectStealCard = null;
        }
        this.scene.input.on("pointerdown", this.resurrectStealOnDown);
    }

    updateSlot(card, cardIndex) {
        if (!this.card && card && card.texture) { //run only ONCE when the card is first created
            this.card = this.scene.add.card(this.x, this.y, card).setDepth(this.depth + 1).setRotation(this.rotation);
            this.isPlusNeg = (card.texture.slice(0, 8) === "plus_neg") || (card.texture === "tie_breaker");
            this.is1Or11 = card.texture === "1_or_11";
            this.isSteal = card.texture === "steal";
            this.isResurrect = card.texture === "resurrect";

            function isInPlayerBoard(pointer, playerBoard) {
                return (pointer.x > playerBoard.x - playerBoard.effectiveWidth / 2 && pointer.x < playerBoard.x + playerBoard.effectiveWidth / 2 && pointer.y > playerBoard.y - playerBoard.effectiveHeight / 2 && pointer.y < playerBoard.y + playerBoard.effectiveHeight / 2);
            }

            if (card.texture !== "back") { //displaying player's cards
                //this.card.dragDistanceThreshold = 20;
                this.card.on('dragstart', (pointer, dragX, dragY) => {                 
                    if (!this.isSteal) {
                        this.scene.playerBoard.setDragOverBorder(true);
                    }
                    else {
                        this.scene.opponentBoard.setDragOverBorder(true);
                        this.scene.opponentBoard.setStealBorder(pointer.x, pointer.y);
                    }

                    this.card.setDepth(998);
                    this.card.setTint(0x999999);
                    if (this.card.bubbleTexture) {
                        this.card.bubbleTexture.setDepth(999);
                        this.card.bubbleTexture.setTint(0x999999);
                    }
                });
                this.card.on('drag', (pointer, dragX, dragY) => {
                    this.card.handleDrag(pointer.x + 170, pointer.y + 184); //offset card from pointer position
                    if (this.isSteal) {                     
                        this.scene.opponentBoard.setDragOverBorder(true);
                        this.scene.opponentBoard.setStealBorder(pointer.x, pointer.y)
                    }
                });
                this.card.on('dragend', async (pointer, dragX, dragY) => {
                    const playerBoard = this.scene.playerBoard
                    const opponentBoard = this.scene.opponentBoard

                    if ((!this.isSteal && isInPlayerBoard(pointer, playerBoard)) || (this.isSteal && opponentBoard.determineIndex(pointer.x, pointer.y) !== -1)) { //pointer is in a valid place to play the power card
                        setTimeout(() => {
                            if (this.card) {
                                this.card.handleDrag(this.x, this.y); //revert to original position inside cardSlot if card was not played
                            }
                        }, 1500)
                    }
                    else {
                        this.card.handleDrag(this.x, this.y); //revert to original position immediately
                    }

                    playerBoard.setDragOverBorder(false); //remove board border
                    opponentBoard.setDragOverBorder(false); //remove board border
                    opponentBoard.setStealBorder(this.x, this.y); //remove steal border

                    this.card.setDepth(this.depth + 1);
                    if (this.card.bubbleTexture) {
                        this.card.bubbleTexture.setDepth(this.depth + 2);
                        this.card.bubbleTexture.clearTint();
                    }
                    this.card.clearTint();

                    //card functionality
                    if (socketConnected && matchIdGame !== "" && !this.isSteal && !this.isResurrect && isInPlayerBoard(pointer, playerBoard)) { //pointer is inside the playerBoard
                        let data;
                        if (this.isPlusNeg) {
                            data = {
                                "name": card.texture,
                                "option": this.plusOrNeg,
                                "cardIndex": cardIndex,
                            }
                        } else if (this.is1Or11) {
                            data = {
                                "name": card.texture,
                                "option": this.oneOrEleven,
                                "cardIndex": cardIndex,
                            }
                        } else {
                            data = {
                                "name": card.texture,
                                "option": null,
                                "cardIndex": cardIndex,
                            }
                        }

                        try {
                            await socket.sendMatchState(matchIdGame, opCodes.playerPlayPowerCard, JSON.stringify(data));
                            //console.log(card.texture + " power card play requested with card index: " + cardIndex);
                        } catch (err) {
                            console.log("Error playing power card: ", err)
                        }
                    }

                    else if (this.isSteal && socketConnected && matchIdGame !== "") {
                        let index = opponentBoard.determineIndex(pointer.x, pointer.y);
                        if (index !== -1) {
                            const data = {
                                "name": "steal",
                                "option": index,
                                "cardIndex": cardIndex,
                            }
                            try {
                                await socket.sendMatchState(matchIdGame, opCodes.playerPlayPowerCard, JSON.stringify(data));
                                console.log("Steal power card play requested on index " + index);
                            } catch (err) {
                                console.log("Error stealing: ", err)
                            }
                        }
                    }

                    else if (this.isResurrect && socketConnected && matchIdGame !== "" && isInPlayerBoard(pointer, playerBoard)) { //pointer is inside the playerBoard
                        displayResurrectModal.value = true; //let Game.jsx do the work
                        displayResurrectModal.cardIndex = cardIndex;
                    }
                });
                this.card.on('pointerover', () => {
                    this.card.setTint(0xbbbbbb);
                });
                this.card.on('pointerout', () => {
                    this.card.clearTint();
                });
            }

            if (this.isPlusNeg) { //+ or - switch button
                this.plusOrNeg = "plus"; //two values: "plus" or "minus"
                this.card.updateBubbleTexture("plus_icon");
                if (!this.switchButtonPlusNeg) {
                    this.switchButtonPlusNeg = this.scene.add.sprite(this.x, this.y + (198*this.scale), 'all_images', this.plusOrNeg === "plus" ? "switch_to_neg" : "switch_to_plus").setScale(this.scale * 1.07).setDepth(this.depth - 1);
                    this.switchButtonPlusNeg.buttonText = this.scene.add.text(this.x - (23.5*this.scale), this.y + (205*this.scale), "SWITCH TO", { fontSize: 38*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FFFFFF', align: 'center' }).setOrigin(0.5, 0.5).setDepth(this.depth - 1);
                    this.switchButtonPlusNeg.on("pointerdown", () => {
                        this.plusOrNeg = this.plusOrNeg === "plus" ? "neg" : "plus"; //switch to the other state when pressed
                        this.switchButtonPlusNeg.setTexture('all_images', this.plusOrNeg === "plus" ? "switch_to_neg" : "switch_to_plus"); //change texture accordingly
                        this.card.updateBubbleTexture(this.plusOrNeg === "plus" ? "plus_icon" : "minus_icon"); //update bubble on card
                    });
                    this.switchButtonPlusNeg.setInteractive();
                }
            }
            else if (this.is1Or11) { //1 or 11 switch button
                this.oneOrEleven = "one"; //two values: "one" or "eleven"
                this.card.updateBubbleTexture("one_icon");
                if (!this.switchButton1Or11) {
                    this.switchButton1Or11 = this.scene.add.sprite(this.x, this.y + (198*this.scale), 'all_images', "switch_green").setScale(this.scale * 1.07).setDepth(this.depth - 1);
                    this.switchButton1Or11.buttonText = this.scene.add.text(this.x, this.y + (205*this.scale), "SWITCH TO 11", { fontSize: 38*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FFFFFF', align: 'center' }).setOrigin(0.5, 0.5).setDepth(this.depth - 1);
                    this.switchButton1Or11.on("pointerdown", () => {
                        this.oneOrEleven = this.oneOrEleven === "one" ? "eleven" : "one"; //switch to the other state when pressed
                        this.switchButton1Or11.buttonText.setText(this.oneOrEleven === "one" ? "SWITCH TO 11" : "SWITCH TO 1"); //change text
                        this.card.updateBubbleTexture(this.oneOrEleven === "one" ? "one_icon" : "eleven_icon"); //update bubble on card
                    });
                    this.switchButton1Or11.setInteractive();
                }
                this.switchButton1Or11.setInteractive();
            }
        }

        else if (!card || card.texture === null) { //recieved null. Slot is empty
            if (this.card) {
                this.card.removeInteractive();
                this.card.updateBubbleTexture(null);
                this.card.destroy();
                this.card = null;
            }
            if (this.switchButtonPlusNeg) {
                this.switchButtonPlusNeg.buttonText.destroy();
                this.switchButtonPlusNeg.destroy();
            }
            if (this.switchButton1Or11) {
                this.switchButton1Or11.buttonText.destroy();
                this.switchButton1Or11.destroy();
            }

            this.isPlusNeg = false;
            this.is1Or11 = false;
            this.isSteal = false;

            return;
        }
    }

    updateInteractive(isTurn) {
        if (!this.card) {
            return;
        }
        
        if (isTurn) {
            this.card.setInteractive({draggable: true});
        }
        else {
            //revert card to original state
            this.card.handleDrag(this.x, this.y); //revert to original position inside cardSlot
            this.scene.playerBoard.setDragOverBorder(false);
            this.scene.opponentBoard.setDragOverBorder(false);
            this.scene.opponentBoard.setStealBorder(this.x, this.y); //remove steal border
            this.card.setDepth(this.depth + 1);
            if (this.card.bubbleTexture) {
                this.card.bubbleTexture.setDepth(this.depth + 2);
                this.card.bubbleTexture.clearTint();
            }
            this.card.clearTint();
            this.card.disableInteractive();
        }
    }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("cardSlot", function (x, y, scale, isEmpty, card, cardIndex, rotation = 0) {
    const cardSlotInst = new CardSlot(this.scene, x, y, scale, isEmpty, card, cardIndex, rotation);

    this.displayList.add(cardSlotInst);
    this.updateList.add(cardSlotInst);

    return cardSlotInst;
})